export default function() {
	'use strict';

	let debounceTimer;
	const delay = 250; // Adjust the delay as needed (e.g., 250 milliseconds)
	const debug = false;

	/**
	 * Build a function that loads SlickJS instance when the block is present.
	 */
	function sponsorsCarousel() {
		debug ? console.log('sponsorsCarousel()') : null;
		const $gallery = $('.sponsorship-feature__slider');

		$gallery.each(function() {
			debug ? console.log('$gallery.each()') : null;
			const $thisSlider = $(this);

			$thisSlider.slick({
				speed: 4000,      // lower number = faster (previously: 15000)
				autoplay: true,
				autoplaySpeed: 0, // keep set to 0
				cssEase: 'linear',
				slidesToShow: 1,
				slidesToScroll: 1,
				variableWidth: true,


				accessibility: true,
				adaptiveHeight: true,
				arrows: false,
				dots: false,
				focusOnSelect:  true,
				infinite: true,
				lazyLoad: 'ondemand',
				mobileFirst: true,
				touchMove: true,
				responsive: [
					{
						breakpoint: 1440,
						settings: {
							slidesToShow: 5,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 1100,
						settings: {
							slidesToShow: 4,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 800,
						settings: {
							slidesToShow: 3,
							slidesToScroll: 1
						}
					},
					{
						breakpoint: 480,
						settings: {
							slidesToShow: 1,
							centerMode: true,
							centerPadding: '40px',
						}
					}
				]
			});
		});
	}


	/**
	 * Build a function that strips certain aria values when the slider isn't being initialized.
	 */
	function sponsorsCarouselAriaFixer() {
		debug ? console.log('sponsorsCarouselAriaFixer()') : null;

		function removeAttributesForSlickItems() {
			// Select all elements with the class name ".slick-item"
			const $slickItems = $('.sponsorship-feature .slick-item');

			debug ? console.log('removeAttributesForSlickItems()') : null;

			// Check the viewport width
			const viewportWidth = $(window).width();

			// Define the breakpoint (in this case, 900 pixels)
			const breakpoint = 900;

			// Iterate through each element with the class ".slick-item"
			$slickItems.each(function() {
				// Check if the viewport width is larger than the breakpoint
				if (viewportWidth > breakpoint) {
					// Remove the "role" and "aria-describedby" attributes
					$(this).removeAttr('role').removeAttr('aria-describedby');
				}
			});
		}

		removeAttributesForSlickItems();
	}

	/**
	 * Fire the function(s) when the page loads.
	 */
	$(window).on('load', function() {
		sponsorsCarousel();
		sponsorsCarouselAriaFixer();
	});

	/**
	 * Debounced the function on resize event.
	 */
	$(window).on('resize', function() {
		clearTimeout(debounceTimer);
		debounceTimer = setTimeout(function() {
			debug ? console.log('resize debounceTimer') : null;
			sponsorsCarouselAriaFixer();
		}, delay);
	});
}
